import * as Types from './operations';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export const ProductGeneralDetailsSectionFragmentDoc = gql`
  fragment ProductGeneralDetailsSection on Product {
    nameEn
    nameLocal
    sku
    productCategory {
      categoryID
      nameEN
      nameLocal
      categoryLevel
      parentCategoryID
    }
    productDescription {
      description
    }
    productAttributes {
      attributeName
      value
    }
    paymentTerm {
      paymentName
    }
  }
`;
export const VariantsPricingFragmentDoc = gql`
  fragment VariantsPricing on Product {
    productOption {
      pricingType
      unitPrice
      currency {
        currencyID
        currencyCode
      }
    }
    productUOM {
      uomID
      commerceDesc
      descriptionTH
    }
  }
`;
export const ProductFileItemFragmentDoc = gql`
  fragment ProductFileItem on ProductFile {
    fileUrl
    originalFileUrl
    order
    originalFileName
    uploadByUserName: uploadByName
    uploadByUserID
    uploadDate
    uuid
  }
`;
export const ProductDescriptionsFragmentDoc = gql`
  fragment ProductDescriptions on Product {
    productFileList {
      ...ProductFileItem
    }
    productDescription {
      description
    }
  }
  ${ProductFileItemFragmentDoc}
`;
export const ProductDetailFragmentDoc = gql`
  fragment ProductDetail on Product {
    productID
    productStatus
    ...ProductGeneralDetailsSection @include(if: $withGeneralDetailsSection)
    ...VariantsPricing @include(if: $withVariantsPricingSection)
    ...ProductDescriptions @include(if: $withDescriptionsSection)
  }
  ${ProductGeneralDetailsSectionFragmentDoc}
  ${VariantsPricingFragmentDoc}
  ${ProductDescriptionsFragmentDoc}
`;
export const CompanyBranchDetailDocument = gql`
  query CompanyBranchDetail($companyID: Long!, $branchID: [Long!]) {
    company(companyID: $companyID) {
      companyNameLocal
      companyNameEn
      branchList(branchIDs: $branchID) {
        branchNumber
        branchNameLocal
        branchNameEn
        useDisplayName
        displayNameLocal
        displayNameEN
      }
      country {
        masterCountryId
        countryName
        countryNameCode
        countryCode
        isEnglishOfficial
        phoneCode
        currencyCode
      }
    }
  }
`;

/**
 * __useCompanyBranchDetailQuery__
 *
 * To run a query within a React component, call `useCompanyBranchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyBranchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyBranchDetailQuery({
 *   variables: {
 *      companyID: // value for 'companyID'
 *      branchID: // value for 'branchID'
 *   },
 * });
 */
export function useCompanyBranchDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.CompanyBranchDetailQuery,
    Types.CompanyBranchDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.CompanyBranchDetailQuery, Types.CompanyBranchDetailQueryVariables>(
    CompanyBranchDetailDocument,
    options,
  );
}
export function useCompanyBranchDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CompanyBranchDetailQuery,
    Types.CompanyBranchDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.CompanyBranchDetailQuery,
    Types.CompanyBranchDetailQueryVariables
  >(CompanyBranchDetailDocument, options);
}
export type CompanyBranchDetailQueryHookResult = ReturnType<typeof useCompanyBranchDetailQuery>;
export type CompanyBranchDetailLazyQueryHookResult = ReturnType<
  typeof useCompanyBranchDetailLazyQuery
>;
export type CompanyBranchDetailQueryResult = Apollo.QueryResult<
  Types.CompanyBranchDetailQuery,
  Types.CompanyBranchDetailQueryVariables
>;
export const ProviderIdpDocument = gql`
  query ProviderIDP($tenantID: String) {
    provider(tenantID: $tenantID) {
      providerKey
      providerGroup
    }
  }
`;

/**
 * __useProviderIdpQuery__
 *
 * To run a query within a React component, call `useProviderIdpQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderIdpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderIdpQuery({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *   },
 * });
 */
export function useProviderIdpQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.ProviderIdpQuery, Types.ProviderIdpQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.ProviderIdpQuery, Types.ProviderIdpQueryVariables>(
    ProviderIdpDocument,
    options,
  );
}
export function useProviderIdpLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ProviderIdpQuery,
    Types.ProviderIdpQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.ProviderIdpQuery, Types.ProviderIdpQueryVariables>(
    ProviderIdpDocument,
    options,
  );
}
export type ProviderIdpQueryHookResult = ReturnType<typeof useProviderIdpQuery>;
export type ProviderIdpLazyQueryHookResult = ReturnType<typeof useProviderIdpLazyQuery>;
export type ProviderIdpQueryResult = Apollo.QueryResult<
  Types.ProviderIdpQuery,
  Types.ProviderIdpQueryVariables
>;
export const ProductDetailDocument = gql`
  query ProductDetail(
    $productID: Int!
    $withGeneralDetailsSection: Boolean = true
    $withVariantsPricingSection: Boolean = true
    $withDescriptionsSection: Boolean = true
  ) {
    product(productID: $productID) {
      ...ProductDetail
    }
  }
  ${ProductDetailFragmentDoc}
`;

/**
 * __useProductDetailQuery__
 *
 * To run a query within a React component, call `useProductDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDetailQuery({
 *   variables: {
 *      productID: // value for 'productID'
 *      withGeneralDetailsSection: // value for 'withGeneralDetailsSection'
 *      withVariantsPricingSection: // value for 'withVariantsPricingSection'
 *      withDescriptionsSection: // value for 'withDescriptionsSection'
 *   },
 * });
 */
export function useProductDetailQuery(
  baseOptions: Apollo.QueryHookOptions<Types.ProductDetailQuery, Types.ProductDetailQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.ProductDetailQuery, Types.ProductDetailQueryVariables>(
    ProductDetailDocument,
    options,
  );
}
export function useProductDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.ProductDetailQuery,
    Types.ProductDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.ProductDetailQuery, Types.ProductDetailQueryVariables>(
    ProductDetailDocument,
    options,
  );
}
export type ProductDetailQueryHookResult = ReturnType<typeof useProductDetailQuery>;
export type ProductDetailLazyQueryHookResult = ReturnType<typeof useProductDetailLazyQuery>;
export type ProductDetailQueryResult = Apollo.QueryResult<
  Types.ProductDetailQuery,
  Types.ProductDetailQueryVariables
>;
export const SupplierProductListDocument = gql`
  query SupplierProductList($input: ProductListInput!, $lang: LangType!) {
    supplierProductList(input: $input) {
      items {
        productID
        nameEN
        nameLocal
        sku
        status
        productImageUrl
        category {
          categoryID
          name(lang: $lang)
          nameEN
          nameLocal
          level
        }
        company {
          companyID
          branch {
            branchID
            number
            nameEN
            nameLocal
          }
        }
      }
      totalPage
      totalItem
      page
      pageSize
    }
  }
`;

/**
 * __useSupplierProductListQuery__
 *
 * To run a query within a React component, call `useSupplierProductListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierProductListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierProductListQuery({
 *   variables: {
 *      input: // value for 'input'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useSupplierProductListQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SupplierProductListQuery,
    Types.SupplierProductListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.SupplierProductListQuery, Types.SupplierProductListQueryVariables>(
    SupplierProductListDocument,
    options,
  );
}
export function useSupplierProductListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SupplierProductListQuery,
    Types.SupplierProductListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SupplierProductListQuery,
    Types.SupplierProductListQueryVariables
  >(SupplierProductListDocument, options);
}
export type SupplierProductListQueryHookResult = ReturnType<typeof useSupplierProductListQuery>;
export type SupplierProductListLazyQueryHookResult = ReturnType<
  typeof useSupplierProductListLazyQuery
>;
export type SupplierProductListQueryResult = Apollo.QueryResult<
  Types.SupplierProductListQuery,
  Types.SupplierProductListQueryVariables
>;
